'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollTo = exports.handleScroll = exports.fixSidebar = undefined;

require('scrolltofixed');

var fixSidebar = exports.fixSidebar = function fixSidebar() {
  var $fixedSideBar = $('.sidebar-fixed');
  var fixed = false;

  if ($(window).innerWidth() >= 992) {
    if (!fixed) {
      $fixedSideBar.scrollToFixed({
        marginTop: 180,
        limit: function limit() {
          var limit = $('.global-footer').offset().top - $fixedSideBar.height() - 40;

          return limit;
        },

        zIndex: 6,
        removeOffsets: true,
        preFixed: function preFixed() {
          $fixedSideBar.removeClass('force-bottom');
        },
        preAbsolute: function preAbsolute() {
          $fixedSideBar.addClass('force-bottom');
        }
      });

      fixed = true;
    }
  } else if (fixed) {
    fixed.trigger('detach.ScrollToFixed');
    fixed = false;
  }
};

var handleScroll = exports.handleScroll = function handleScroll(target) {
  var additionalOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var headerHeight = $('.header-main').outerHeight();
  var scrollTarget = $(target).offset().top - headerHeight - additionalOffset;

  $('html, body').animate({
    scrollTop: scrollTarget
  });
};

var scrollTo = exports.scrollTo = function scrollTo(event) {
  event.preventDefault();
  var target = document.querySelector(event.currentTarget.dataset.scrollTo);
  var headerHeight = document.querySelector('[data-header-main]').clientHeight;
  var filterHeight = document.querySelector('.collection-filter-bar-inner') ? document.querySelector('.collection-filter-bar-inner').clientHeight + document.querySelector('.collection-active-filters').clientHeight : 0;
  var extraPadding = headerHeight + filterHeight;
  var distanceToTop = target.getBoundingClientRect().top - extraPadding;

  window.scrollBy({ top: distanceToTop, left: 0, behavior: 'smooth' });
};